import React from "react";

export const INPUT = "w-full border-2 border-black px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-black/20 disabled:bg-zinc-100 disabled:text-zinc-600";

export const Section = ({ n, title, hint, children, testId }) => (
  <section className="border-2 border-black bg-white p-5 sm:p-7 ob-rise" data-testid={testId}>
    <div className="flex items-baseline gap-3 mb-1">
      <span className="font-mono text-xs text-zinc-500">{String(n).padStart(2, "0")}</span>
      <h2 className="font-chivo font-black uppercase tracking-tight text-base md:text-lg">{title}</h2>
    </div>
    {hint && <p className="text-xs text-zinc-600 mb-5 max-w-2xl">{hint}</p>}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4">{children}</div>
  </section>
);

export const Field = ({ label, hint, required, wide, children }) => (
  <div className={wide ? "sm:col-span-2" : ""}>
    <div className="label-mono">{label}{required && <span className="text-red-700"> *</span>}</div>
    <div className="mt-1">{children}</div>
    {hint && <div className="mt-1 text-[11px] text-zinc-500">{hint}</div>}
  </div>
);

export const TextIn = ({ a, set, k, testId, ro, area, ...rest }) => {
  const Tag = area ? "textarea" : "input";
  return (
    <Tag className={INPUT} value={a[k] ?? ""} disabled={ro} rows={area ? 3 : undefined}
         onChange={(e) => set(k, e.target.value)} data-testid={testId} {...rest} />
  );
};

export const NumIn = ({ a, set, k, testId, ro, placeholder }) => (
  <input type="number" min={1} className={INPUT} value={a[k] ?? ""} disabled={ro} placeholder={placeholder}
         onChange={(e) => set(k, e.target.value ? Math.max(1, Math.round(Number(e.target.value))) : null)} data-testid={testId} />
);

export const Choice = ({ on, onClick, children, testId, ro }) => (
  <button type="button" disabled={ro} onClick={onClick} data-testid={testId} aria-pressed={on}
          className={`border-2 border-black px-3 py-2 text-xs text-left transition-colors duration-100 ${on ? "bg-black text-white" : "bg-white hover:bg-zinc-100"} disabled:cursor-not-allowed`}>
    {children}
  </button>
);

export const Tick = ({ checked, onChange, children, testId, ro }) => (
  <label className={`flex items-start gap-2 text-sm ${ro ? "" : "cursor-pointer"}`}>
    <input type="checkbox" className="accent-black h-4 w-4 mt-0.5 shrink-0" checked={!!checked} disabled={ro}
           onChange={(e) => onChange(e.target.checked)} data-testid={testId} />
    <span>{children}</span>
  </label>
);
